import { routePaths } from "@/shared/config/routePaths";
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const OrganizationsPage = lazy(() => import('./OrganizationsPage').then(m => ({ default: m.OrganizationsPage })));
const EntitlementsManagerPage = lazy(() => import('./EntitlementsManagerPage').then(m => ({ default: m.EntitlementsManagerPage })));

export const administrationRouter: RouteObject = {
    path: routePaths.administration.base,
    children: [
        {
            path: routePaths.administration.organizations.relative,
            element: <OrganizationsPage />
        },
        {
            path: routePaths.administration.entitlementsManager.relative,
            element: <EntitlementsManagerPage />
        },

    ]
}
